import React, { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Download } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadCaptureSection = () => {
  const [leadEmail, setLeadEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = leadEmail.trim();
    if (!trimmed) {
      toast.error('Please enter your email');
      return;
    }
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
    if (!emailOk) {
      toast.error('Please enter a valid email address.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API_BASE}/leads`, { email: trimmed });
      if (res.data.success) {
        toast.success("You're in. Check your inbox for the worksheet.");
        setLeadEmail('');
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not subscribe. Try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <Card className="border-2 border-primary/30 bg-card overflow-hidden">
            <CardContent className="p-8 md:p-10">
              <div className="grid md:grid-cols-5 gap-6 items-center">
                <div className="md:col-span-2 flex justify-center md:justify-start">
                  <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center">
                    <Download className="w-10 h-10 text-primary" />
                  </div>
                </div>
                <div className="md:col-span-3 space-y-3">
                  <h3 className="text-2xl font-serif font-bold text-foreground">
                    Free CBT Reframing Worksheet
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    One of the most loved tools in my practice — a simple 3-column log to catch anxious thoughts before they spiral. Instant delivery to your inbox.
                  </p>
                  <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2 pt-2">
                    <Input
                      type="email"
                      placeholder="Your email"
                      value={leadEmail}
                      onChange={(e) => setLeadEmail(e.target.value)}
                      required
                      data-testid="lead-email-input"
                      className="flex-1"
                    />
                    <Button
                      type="submit"
                      disabled={submitting}
                      className="bg-primary hover:bg-primary/90"
                      data-testid="lead-submit-btn"
                    >
                      {submitting ? 'Sending…' : 'Send Me the Worksheet'}
                    </Button>
                  </form>
                  <p className="text-xs text-muted-foreground italic">
                    No spam. Just one short note this week on how to use it.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
